import { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { applicationService } from "../services/applicationService";
import toast from "react-hot-toast";
import fallBackImage from '../Assests/images/placeholderimage.jpg'
import { XMarkIcon } from "@heroicons/react/24/outline";
import Multiselect from 'multiselect-react-dropdown';

export default function ApplicationModal({
    isOpen,
    onClose,
    type,
    selectedApp = {},
    setSelectedApp = () => { },
    setModelType,
    getAllApplicationList,
}) {
    const [allSubjects, setAllSubjects] = useState([])
    const [allGrades, setAllGrades] = useState([])
    const [allEducator, setAllEducator] = useState([])
    const [appIconFile, setAppIconFile] = useState(null);
    const [appIconName, setappIconName] = useState('')
    const [attachmentFile, setAttachmentFile] = useState('');
    const [loader, setLoader] = useState(false)

    const [initialValues, setInitialValues] = useState({
        appName: "",
        subject: "",
        gradeLevel: "",
        description: "",
        maxRegistration: "",
        educator: "",
        location: "",
        appIcon: null,
        attachment: null,
    });

    useEffect(() => {
        if (isOpen == true) {
            getAllSubjectData()
            getAllGradeData()
            getAllEducatorData()
        }
    }, [isOpen])

    useEffect(() => {
        if (type == 'Edit') {
            setInitialValues({
                appName: selectedApp?.name,
                subject: selectedApp?.subject_id,
                gradeLevel: selectedApp?.grade_id,
                description: selectedApp?.description,
                maxRegistration: selectedApp?.max_registration,
                educator: selectedApp?.educator_id,
                location: selectedApp?.location,
                appIcon: selectedApp?.icon,
                attachment: selectedApp?.attachment_link,
            })
            setAppIconFile(selectedApp?.icon)
            setappIconName(selectedApp?.icon_name)
            setAttachmentFile(selectedApp?.attachment_link_name)
        } else {
            setInitialValues({
                appName: "",
                subject: "",
                gradeLevel: "",
                description: "",
                maxRegistration: "",
                educator: "",
                location: "",
                appIcon: null,
                attachment: null,
            })
            setAppIconFile(null)
            setappIconName('')
            setAttachmentFile('')
        }
    }, [type])

    if (!isOpen) return null;

    const validationSchema = Yup.object({
        appName: Yup.string().required("Application name is required"),
        subject: Yup.string().required("Subject is required"),
        gradeLevel: Yup.string().required("Grade Level is required"),
        description: Yup.string().required("Description is required"),
        maxRegistration: Yup.number().required("Required"),
        educator: Yup.string().required("Educator is required"),
        location: Yup.string().required("Location is required"),
    });

    async function getAllSubjectData() {
        try {
            const response = await applicationService.getAllSubject()
            if (response?.success == true) {
                setAllSubjects(response?.data)
            } else {
                setAllSubjects([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getAllGradeData() {
        try {
            const response = await applicationService.getAllGrades()
            if (response?.success == true) {
                setAllGrades(response?.data)
            } else {
                setAllGrades([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }
    async function getAllEducatorData() {
        try {
            const response = await applicationService.getAllEductorList()
            if (response?.success == true) {
                setAllEducator(response?.data)
            } else {
                setAllEducator([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    const handleSubmit = async (values, resetForm) => {
        try {
            setLoader(true)
            let applicationData = new FormData();

            if (type === "Edit") {
                applicationData.append("id", selectedApp?.application_id);
            }

            applicationData.append("name", values?.appName);
            applicationData.append("description", values?.description);
            applicationData.append("category", "Admin");
            applicationData.append("subject_id", values?.subject);
            applicationData.append("grade_id", values?.gradeLevel);
            applicationData.append("max_registration", values?.maxRegistration);
            applicationData.append("educator_id", values?.educator);
            applicationData.append("location", values?.location);
            applicationData.append("icon", values?.appIcon);
            applicationData.append("attachment_link", values?.attachment);

            const response = await applicationService.createApplication(applicationData)
            await getAllApplicationList()
            if (response.success == true) {
                onClose(false)
                setLoader(false)
                setModelType('')
                setAppIconFile(null)
                setappIconName('')
                setAttachmentFile('')
                if (type == 'Edit') {
                    toast.success(response?.message || 'Application updated successfully')
                    setSelectedApp({})
                } else {
                    toast.success(response?.message || 'Application created successfully')
                }
                resetForm()
            }
        } catch (e) {
            setLoader(false)
            toast.error(e.response.data.message || 'failed to create application')
        }
    };

    const closeModel = () => {
        onClose(false)
        setLoader(false)
        setModelType('')
        setAppIconFile(null)
        setappIconName('')
        setAttachmentFile('')
        if (type == 'Edit') {
            setSelectedApp({})
        }
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Overlay */}
            <div
                className="absolute inset-0 bg-black bg-opacity-40"
                onClick={closeModel}
            ></div>

            {/* Modal Content */}
            <div className="relative bg-white rounded-xl shadow-lg w-full max-w-2xl p-6">
                {/* Header */}
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h2 className="text-lg text-[#283C50] font-semibold">
                        {type == 'Edit' ? "Edit Application" : "Add New Application"}
                    </h2>
                    <button
                        onClick={closeModel}
                        className="text-gray-400 hover:text-gray-600 text-xl"
                    >
                        ✕
                    </button>
                </div>

                {/* Formik Form */}
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue }) => (
                        <Form >
                            <div className="max-h-[650px] overflow-y-auto pr-2 scrollbar-hide">
                                {/* Application Name */}
                                <label className="text-md text-[#717576] font-normal">
                                    Enter application name
                                </label>
                                <Field
                                    name="appName"
                                    type="text"
                                    placeholder="Your Application Name Here"
                                    className="w-full border p-3 my-[9px] bg-[#7175760F] h-[60px] rounded-[10px]"
                                />
                                <ErrorMessage
                                    name="appName"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* Subject */}
                                <label className="text-md text-[#717576] font-normal">Subject</label>
                                <div className="relative">
                                    <Field
                                        as="select"
                                        name="subject"
                                        className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                    >
                                        <option value="">Select Subject</option>
                                        {(allSubjects && allSubjects.length > 0) &&
                                            allSubjects.map((item, index) => {
                                                return (
                                                    <option value={item?.subject_id} key={index}>{item?.name}</option>
                                                )
                                            })
                                        }
                                    </Field>

                                    {/* Custom dropdown arrow */}
                                    <svg
                                        width="20"
                                        height="11"
                                        viewBox="0 0 20 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                    >
                                        <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                    </svg>
                                </div>

                                <ErrorMessage
                                    name="subject"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* Grade Level */}
                                <label className="text-md text-[#717576] font-normal">
                                    Grade Level(s)
                                </label>
                                <div className="relative">
                                    <Field
                                        as="select"
                                        name="gradeLevel"
                                        className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                    >
                                        <option value="">Select grade</option>
                                        {(allGrades && allGrades.length > 0) &&
                                            allGrades.map((item, index) => {
                                                return (
                                                    <option value={item?.grade_id} key={index}>{item?.grade_name}</option>
                                                )
                                            })
                                        }
                                    </Field>

                                    {/* Custom dropdown arrow */}
                                    <svg
                                        width="20"
                                        height="11"
                                        viewBox="0 0 20 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                    >
                                        <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                    </svg>
                                </div>
                                <ErrorMessage
                                    name="gradeLevel"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* Description */}
                                <label className="text-md text-[#717576] font-normal">
                                    Description
                                </label>
                                <Field
                                    as="textarea"
                                    name="description"
                                    placeholder="Brief description of the application"
                                    className="w-full border p-2 text-md my-[9px] bg-[#7175760F] rounded-[10px]"
                                    rows={4}
                                />
                                <ErrorMessage
                                    name="description"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* Max Registration */}
                                <label className="text-md text-[#717576] font-normal">
                                    Max Registration
                                </label>
                                <Field
                                    name="maxRegistration"
                                    type="number"
                                    placeholder="Max Registration"
                                    className="w-full border p-2 text-md my-[9px] bg-[#7175760F] h-[60px] rounded-[10px] remove_numberarrows"
                                />
                                <ErrorMessage
                                    name="maxRegistration"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* Educator */}
                                <label className="text-md text-[#717576] font-normal">
                                    Educator
                                </label>
                                {/* <div className="relative">
                                    <Field
                                        as="select"
                                        name="educator"
                                        className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                    >
                                        <option value="">Select Educator</option>
                                        {(allEducator && allEducator.length > 0) &&
                                            allEducator.map((item, index) => {
                                                return (
                                                    <option value={item?.user_id} key={index}>{item?.full_name}</option>
                                                )
                                            })
                                        }
                                    </Field>

                                    <svg
                                        width="20"
                                        height="11"
                                        viewBox="0 0 20 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                    >
                                        <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                    </svg>
                                </div> */}
                                <div className="relative">
                                    <Multiselect
                                        options={allEducator}
                                        selectedValues={
                                            values?.educator
                                                ? allEducator.filter((e) => {
                                                    let ids = [];

                                                    // Handle both string ("1,2,3") and array ([1,2,3])
                                                    if (typeof values?.educator === "string") {
                                                        ids = values?.educator.split(",").map((id) => Number(id.trim()));
                                                    } else if (Array.isArray(values?.educator)) {
                                                        ids = values?.educator.map((id) => Number(id));
                                                    }

                                                    return ids.includes(e?.user_id);
                                                })
                                                : []
                                        }
                                        onSelect={(selectedList) => {
                                            const educatorIds = selectedList.map((item) => item?.user_id).join(",");
                                            setFieldValue("educator", educatorIds);
                                        }}
                                        onRemove={(selectedList) => {
                                            const educatorIds = selectedList.map((item) => item?.user_id).join(",");
                                            setFieldValue("educator", educatorIds);
                                        }}
                                        displayValue="full_name"
                                        placeholder="Select Educator"
                                        className="text-md my-[9px] rounded-[10px] multiselectCustomClass"
                                    />
                                    <svg
                                        width="20"
                                        height="11"
                                        viewBox="0 0 20 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                    >
                                        <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                    </svg>
                                </div>
                                <ErrorMessage
                                    name="educator"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* Location */}
                                <label className="text-md text-[#717576] font-normal">
                                    Enter Location
                                </label>
                                <Field
                                    name="location"
                                    type="text"
                                    placeholder="Enter location"
                                    className="w-full border p-2 text-md my-[9px] bg-[#7175760F] h-[60px] rounded-[10px]"
                                />
                                <ErrorMessage
                                    name="location"
                                    component="div"
                                    className="text-red-500 text-sm"
                                />

                                {/* File Uploads */}
                                <div>
                                    {/* App Icon */}
                                    <div>
                                        <label className="text-md text-[#717576] font-normal block mb-2">
                                            Upload App Icon
                                        </label>
                                        <input
                                            id="appIcon"
                                            name="appIcon"
                                            type="file"
                                            accept="image/png, image/jpeg"
                                            className="hidden"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file && file.type === "image/png" || file.type === "image/jpeg") {
                                                    setFieldValue("appIcon", file);
                                                    setappIconName(file?.name)
                                                    setAppIconFile(URL.createObjectURL(file));
                                                } else {
                                                    toast.error('Please upload a valid image (PNG or JPEG only).')
                                                }
                                            }}
                                        />
                                        <div className="relative">
                                            {appIconFile !== null && <XMarkIcon className="absolute top-2 right-2 w-5 h-5 cursor-pointer" onClick={() => {
                                                setFieldValue("appIcon", null);
                                                setappIconName('')
                                                setAppIconFile(null);
                                            }} />}
                                            <label
                                                htmlFor="appIcon"
                                                className="w-full border rounded-[10px] bg-[#F7F7F7] h-[100px] flex flex-col items-center justify-center cursor-pointer text-gray-500 hover:bg-gray-100 transition text-center px-3"
                                            >
                                                {appIconFile ? (
                                                    <>
                                                        <img
                                                            src={appIconFile || fallBackImage}
                                                            alt="Preview"
                                                            className="h-[60px] object-contain mb-1 rounded-lg"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = fallBackImage;
                                                            }}
                                                        />
                                                        <span className="text-sm text-gray-700 truncate w-full">
                                                            {appIconName}
                                                        </span>
                                                    </>
                                                ) : (

                                                    <div className="flex flex-col items-center">
                                                        <span>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M8.82144 17.3029C7.76724 17.3029 6.98904 17.2843 6.27264 17.2663C5.66424 17.2519 5.10024 17.2381 4.44684 17.2381C3.42138 17.237 2.43822 16.8292 1.71305 16.1041C0.987881 15.379 0.579912 14.396 0.578642 13.3705C0.576212 12.7411 0.728545 12.1207 1.02223 11.564C1.31592 11.0072 1.74196 10.5312 2.26284 10.1779C2.1761 9.7558 2.13247 9.32599 2.13264 8.89509C2.13264 5.38989 4.98444 2.53809 8.49024 2.53809C10.8374 2.53809 12.9872 3.83649 14.0894 5.88249C14.4485 5.51471 14.8778 5.22276 15.3518 5.02395C15.8258 4.82514 16.3348 4.72351 16.8488 4.72509C17.4364 4.72564 18.0162 4.85991 18.5442 5.1177C19.0722 5.3755 19.5346 5.75007 19.8964 6.21305C20.2582 6.67603 20.5099 7.21527 20.6324 7.78993C20.755 8.36459 20.7451 8.95959 20.6036 9.52989C21.4151 9.75878 22.1297 10.2464 22.6386 10.9187C23.1475 11.5909 23.4229 12.4109 23.423 13.2541C23.4219 14.2797 23.0141 15.263 22.2889 15.9883C21.5637 16.7136 20.5805 17.1216 19.5548 17.1229C18.5582 17.1229 17.8586 17.1307 17.1674 17.1373C16.4918 17.1445 15.824 17.1517 14.897 17.1517C14.8175 17.1517 14.7412 17.1201 14.6849 17.0638C14.6286 17.0076 14.597 16.9313 14.597 16.8517C14.597 16.7721 14.6286 16.6958 14.6849 16.6396C14.7412 16.5833 14.8175 16.5517 14.897 16.5517C15.8216 16.5517 16.487 16.5445 17.1608 16.5373C17.8538 16.5301 18.5558 16.5229 19.5548 16.5229C20.3689 16.5239 21.154 16.2211 21.7565 15.6738C22.359 15.1264 22.7356 14.3739 22.8125 13.5635C22.8895 12.7532 22.6612 11.9432 22.1724 11.2923C21.6836 10.6413 20.9695 10.1962 20.1698 10.0441C20.1277 10.036 20.0877 10.019 20.0527 9.99411C20.0177 9.96926 19.9884 9.93718 19.9668 9.90003C19.9453 9.86289 19.9319 9.82155 19.9277 9.77881C19.9235 9.73607 19.9285 9.69292 19.9424 9.65229C20.1104 9.16005 20.1586 8.63485 20.0831 8.12026C20.0075 7.60567 19.8103 7.11652 19.5078 6.6934C19.2053 6.27027 18.8063 5.92536 18.3439 5.68729C17.8815 5.44922 17.369 5.32485 16.8488 5.32449C16.3477 5.32296 15.853 5.4375 15.4035 5.65911C14.954 5.88073 14.562 6.20342 14.258 6.60189C14.2266 6.64325 14.1848 6.67568 14.1369 6.69597C14.0891 6.71627 14.0368 6.72372 13.9851 6.7176C13.9335 6.71148 13.8844 6.692 13.8426 6.66108C13.8008 6.63015 13.7678 6.58887 13.7468 6.54129C13.2912 5.52825 12.553 4.6682 11.6207 4.06434C10.6884 3.46047 9.60162 3.13844 8.49084 3.13689C5.31624 3.13689 2.73324 5.71929 2.73324 8.89389C2.73324 9.34989 2.78724 9.80469 2.89344 10.2451C2.90839 10.307 2.90324 10.372 2.87876 10.4308C2.85427 10.4896 2.81171 10.5391 2.75724 10.5721C2.2742 10.8614 1.87472 11.2714 1.59806 11.7619C1.3214 12.2523 1.17707 12.8062 1.17924 13.3693C1.18035 14.2357 1.52506 15.0662 2.13774 15.6788C2.75042 16.2914 3.58106 16.6359 4.44744 16.6369C5.10624 16.6369 5.67444 16.6501 6.28764 16.6657C7.00044 16.6825 7.77384 16.7017 8.82204 16.7017C8.90177 16.7018 8.97819 16.7335 9.03451 16.7899C9.09083 16.8464 9.12242 16.9229 9.12234 17.0026C9.12226 17.0823 9.09052 17.1587 9.03409 17.2151C8.97766 17.2714 8.90117 17.303 8.82144 17.3029Z" fill="#717576" fillOpacity="0.5" />
                                                                <path d="M15.8099 13.4737C15.7323 13.4737 15.6576 13.4436 15.6017 13.3897L11.5355 9.46866L7.48791 13.3735C7.43055 13.4287 7.3536 13.4588 7.27399 13.4573C7.19438 13.4558 7.11863 13.4227 7.06341 13.3654C7.0082 13.308 6.97803 13.231 6.97955 13.1514C6.98107 13.0718 7.01415 12.9961 7.07151 12.9409L11.3273 8.83626C11.3831 8.78229 11.4577 8.75207 11.5354 8.75195C11.613 8.75184 11.6877 8.78185 11.7437 8.83566L16.0175 12.9571C16.0607 12.9985 16.0906 13.0519 16.1032 13.1105C16.1158 13.169 16.1106 13.23 16.0883 13.2855C16.066 13.3411 16.0275 13.3887 15.9779 13.4222C15.9283 13.4558 15.8698 13.4737 15.8099 13.4737Z" fill="#717576" fillOpacity="0.5" />
                                                                <path d="M11.5358 21.4614C11.4563 21.4614 11.38 21.4298 11.3237 21.3735C11.2674 21.3173 11.2358 21.241 11.2358 21.1614V9.0522C11.2358 8.97263 11.2674 8.89633 11.3237 8.84007C11.38 8.7838 11.4563 8.7522 11.5358 8.7522C11.6154 8.7522 11.6917 8.7838 11.748 8.84007C11.8042 8.89633 11.8358 8.97263 11.8358 9.0522V21.162C11.8357 21.2415 11.804 21.3176 11.7478 21.3737C11.6915 21.4299 11.6153 21.4614 11.5358 21.4614Z" fill="#717576" fillOpacity="0.5" />
                                                            </svg>

                                                        </span>
                                                        <span className="text-sm text-center">
                                                            PNG/JPG, recommended 512x512</span>

                                                    </div>

                                                )}
                                            </label>
                                        </div>
                                    </div>

                                    {/* Attachment */}
                                    <div className="mt-4">
                                        <label className="text-md text-[#717576] font-normal block mb-2">
                                            Attachment
                                        </label>
                                        <input
                                            id="attachment"
                                            name="attachment"
                                            type="file"
                                            accept=".doc, .docx, .pdf"
                                            className="hidden"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (!file) {
                                                    setFieldValue("attachment", null);
                                                    setAttachmentFile('');
                                                }
                                                const allowedTypes = [
                                                    "application/pdf",
                                                    "application/msword",
                                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                ];
                                                if (allowedTypes.includes(file.type)) {
                                                    setFieldValue("attachment", file);
                                                    setAttachmentFile(file?.name);
                                                } else {
                                                    toast.error('Please upload a valid file (Docs or Pdf only).')
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor="attachment"
                                            className="w-full border rounded-[10px] bg-[#F7F7F7] h-[60px] flex items-center px-4 cursor-pointer hover:bg-gray-100 transition"
                                        >
                                            {attachmentFile ? (
                                                <span className="text-gray-700 text-sm truncate">
                                                    {attachmentFile}
                                                </span>
                                            ) : (
                                                <span className="text-gray-500 text-sm">
                                                    Add your attachment here
                                                </span>
                                            )}

                                            {/* Icon always on the far right */}
                                            <span className="ml-auto flex items-center">
                                                <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M19.4632 5.57604C18.7752 4.82604 17.5342 4.78004 16.7072 5.60704L8.60718 13.707C8.39718 13.917 8.39718 14.183 8.60718 14.393C8.81718 14.603 9.08318 14.603 9.29318 14.393L15.9932 7.69304C16.1818 7.51089 16.4344 7.41009 16.6966 7.41237C16.9588 7.41465 17.2096 7.51982 17.395 7.70523C17.5804 7.89063 17.6856 8.14145 17.6879 8.40364C17.6901 8.66584 17.5893 8.91844 17.4072 9.10704L10.7072 15.807C10.4788 16.042 10.2057 16.2288 9.90391 16.3563C9.60212 16.4839 9.27782 16.5496 8.95018 16.5496C8.62255 16.5496 8.29824 16.4839 7.99645 16.3563C7.69466 16.2288 7.42152 16.042 7.19318 15.807C6.95822 15.5787 6.77145 15.3056 6.64391 15.0038C6.51637 14.702 6.45065 14.3777 6.45065 14.05C6.45065 13.7224 6.51637 13.3981 6.64391 13.0963C6.77145 12.7945 6.95822 12.5214 7.19318 12.293L15.2932 4.19304C16.8602 2.62504 19.4082 2.57404 20.9232 4.20804C22.4752 5.77704 22.5202 8.31204 20.8932 9.82104L11.4072 19.307C9.21718 21.497 5.78318 21.497 3.59318 19.307C1.40318 17.117 1.40318 13.683 3.59318 11.493L11.6932 3.39304C11.8818 3.21089 12.1344 3.11009 12.3966 3.11237C12.6588 3.11465 12.9096 3.21982 13.095 3.40523C13.2804 3.59063 13.3856 3.84145 13.3879 4.10364C13.3901 4.36584 13.2893 4.61844 13.1072 4.80704L5.00718 12.907C3.59718 14.317 3.59718 16.483 5.00718 17.893C6.41718 19.303 8.58318 19.303 9.99318 17.893L19.4932 8.39304L19.5242 8.36304C20.2742 7.67604 20.3202 6.43404 19.4932 5.60704L19.4632 5.57604Z"
                                                        fill="#496EB4"
                                                    />
                                                </svg>
                                            </span>
                                        </label>

                                    </div>
                                </div>

                            </div>
                            {/* Footer */}
                            <div className="flex justify-between gap-3 pt-4">
                                <button
                                    type="button"
                                    onClick={closeModel}
                                    className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition btn-primary"
                                >
                                    {type == 'Edit' ?
                                        <>
                                            {loader ?
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white-600 mr-2"></div>
                                                    Updating...
                                                </>
                                                :
                                                'Save & Update'
                                            }
                                        </>
                                        :
                                        <>
                                            {loader ?
                                                <>
                                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white-600 mr-2"></div>
                                                    Creating...
                                                </>
                                                :
                                                'Save & Add'
                                            }
                                        </>
                                    }
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
}
